// The line kind's visual identity — ONE map for every row that renders a kind
// (proposal rows, template rows), so the icon for « labor » cannot drift
// between editors.
import { Package, Wrench, Receipt } from 'lucide-vue-next'

export const KIND_ICONS = { material: Package, labor: Wrench, fee: Receipt } as const

export type LineKind = keyof typeof KIND_ICONS

// The i18n key for a kind's label (callers t() it — locale stays reactive).
export const kindLabelKey = (kind: string) => `proposals.lineItemKind.${kind}`
